<script>
import { conciliacaoClient } from '../../../libs/conciliacao-client'
import format from 'date-fns/format'
import ptBR from 'date-fns/locale/pt-BR'

export default {
  props: {
    pagamentoLote: { type: Object, required: true }
  },
  data () {
    return {
      pagamento: {},
      statusPagamentoCliente: [
        "conciliacaoAutomaticaCliente",
        "conciliacaoManualCliente",
        "conclusaoPendente",
        "gerandoArquivos",
        "concluido"
      ],
    }
  },
  components: {

  },
  methods: {
    async handleResponsavelClick () {
      await conciliacaoClient.pagamentoLote.updateResponsavel(this.pagamentoLote.id)

      this.$emit("reloadPage")
    },
    async handleLimparResponsavelClick () {
      const command = {
        pagamentoId: this.pagamentoLote.pagamentoId,
        responsavelId: null,
        pagamentoLoteIds: [this.pagamentoLote.id]
      }

      await conciliacaoClient.pagamentoLote.updateResponsaveis(command)

      this.$emit("reloadPage")
    },
    async handleConciliacaoAutomaticaClick () {
      const params = {
        pagamentoLoteId: this.pagamentoLote.id
      }
      await conciliacaoClient.conciliacaoExecucao.createConciliacaoExecucao(params)

      this.$emit("reloadPage")
    },
    async handleEncerrarConciliacaoManualClick () {
      const params = {
        pagamentoId: this.pagamentoLote.pagamentoId,
        pagamentoLoteIds: [this.pagamentoLote.id]
      }
      await conciliacaoClient.pagamentoLote.finalizarConciliacoesManuais(params)

      this.$emit("reloadPage")
    },
    async handleDesconciliarClick () {
      const params = {
        pagamentoId: this.pagamentoLote.pagamentoId,
        data: [{
          pagamentoLoteId: this.pagamentoLote.id,
          pagamentoGuiaIds: null
        }]
      }
      await conciliacaoClient.pagamento.desconciliar(params)

      this.$emit("reloadPage")
    },
    handleBackClick () {
      this.$router.push({
        name: 'pagamentoLote',
        params: { pagamentoId: this.pagamentoLote.pagamentoId, pagamentoLoteId: this.pagamentoLote.id }
      })
    },
    formatDate (date) {
      if (date?.toString().match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)) {
        const match = date.toString().match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/)

        return `${match[3]}/${match[2]}/${match[1]}`
      }

      return date ? format(new Date(date), 'Pp', { locale: ptBR }) : '-'
    }
  },
  computed: {
    dataPagamento () {
      return this.pagamentoLote?.dataPagamento
    },
    operadora () {
      return this.pagamentoLote?.operadoraAns?.nome || '-'
    },
    prestador () {
      return this.pagamentoLote?.prestador?.nome || '-'
    },
    responsavel () {
      const responsavel = this.pagamentoLote?.responsavel
      return responsavel ? responsavel.nome : null
    },
    numeroLote () {
      return this.pagamentoLote?.numeroLote || '-'
    },
    responsavelId () {
      return this.pagamentoLote?.responsavelId || null
    },
    isManualSemResponsavel () {
      return (
        this.responsavelId === null
        && this.pagamentoLote?.status === "conciliacaoManual"
        && !this.statusPagamentoCliente.includes(this.pagamento?.status)
      )
    },
    isManualUsuarioResponsavel () {
      return this.responsavelId === this.userId && this.pagamentoLote.status === "conciliacaoManual"
    },
    isFinalizado () {
      return (
        !this.statusPagamentoCliente.includes(this.pagamento?.status)
        && (
          this.pagamentoLote?.status === "conciliado"
          || this.pagamentoLote?.status === "conciliadoParcialmente"
          || this.pagamentoLote?.status === "naoConciliado"
          || this.pagamentoLote?.status === "nenhumaGuiaEncontrada"
          )
        )
    },
    actions () {
      return [
        {
          hideButton: this.responsavelId === this.userId,
          title: "Assumir como responsável",
          onClick: this.handleResponsavelClick,
          disabled: !(this.isManualSemResponsavel || this.isFinalizado),
          tooltipMessage: "Ação requer lote sem responsável ou em status de conciliação finalizada."
        },
        {
          hideButton: this.responsavelId !== this.userId,
          title: "Limpar responsável",
          onClick: this.handleLimparResponsavelClick,
          disabled: !(this.isManualUsuarioResponsavel || this.isFinalizado),
          tooltipMessage: "É necessário ser responsável pelo lote."
        },
        {
          title: "Conciliar automaticamente",
          onClick: this.handleConciliacaoAutomaticaClick,
          disabled: !(this.isManualSemResponsavel || this.isManualUsuarioResponsavel || this.isFinalizado),
          tooltipMessage: "Ação requer lote em 'Conciliação Manual' sem responsável ou atribuído ao usuário."
        },
        {
          title: "Encerrar conciliação manual",
          onClick: this.handleEncerrarConciliacaoManualClick,
          disabled: !(this.isManualUsuarioResponsavel),
          tooltipMessage: "Ação requer lote em 'Conciliação Manual' e atribuído ao usuário."
        },
        {
          title: "Desconciliar tudo",
          onClick: this.handleDesconciliarClick,
          disabled: !(this.isManualUsuarioResponsavel || this.isFinalizado),
          tooltipMessage: "Ação requer lote atribuído ao usuário ou em status de conciliação finalizada."
        }
      ]
    },
  },
  async mounted () {
    const signedUser = await conciliacaoClient.authentication.getSignedUser()

    if (signedUser) {
      this.userId = signedUser.id
    }

    const pagamento = this.pagamentoId !== undefined
      ? await conciliacaoClient.pagamento.getPagamentoById(this.pagamentoId)
      : null

    if (pagamento) {
      this.pagamento = pagamento
    }
  }
}
</script>

<template>
  <div class="d-flex align-center justify-space-between mb-2" style="height: 42px;">
    <div>
      <div class="d-flex">
        <v-btn icon class="mr-2" @click="handleBackClick">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
        <h1>
          <span>Lote de pagamento - {{ numeroLote }}</span>
        </h1>
      </div>
      <div>
        <span style="font-weight: 500;">Data do pagamento:</span> <span>{{ formatDate(dataPagamento || null) }} - </span>
        <span style="font-weight: 500;" v-if="prestador">Prestadora:</span> <span>{{ prestador }} - </span>
        <span style="font-weight: 500;" v-if="operadora">Operadora:</span> <span> {{ operadora }}</span>
      </div>
    </div>
    <div class="d-flex align-center">
      <div v-if="responsavel" class="pr-4">
        <v-chip outlined label small class="ml-2 secondary">
          <span class="secondary--text">{{ responsavel }}</span>
        </v-chip>
      </div>
      <div>
        <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Ações
          </v-btn>
        </template>
        <v-list>
          <template v-for="(action, index) in actions">
              <v-tooltip v-if="!action.hideButton" :disabled="!action.disabled" left :key="index">
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs">
                    <v-list-item
                      :disabled="action.disabled"
                      @click="action.onClick"
                    >
                      <v-list-item-title>{{ action.title }}</v-list-item-title>
                    </v-list-item>
                  </div>
              </template>
              <span>{{ action.tooltipMessage }}</span>
            </v-tooltip>
          </template>
        </v-list>
      </v-menu>
      </div>
    </div>
  </div>
</template>
